import { render, staticRenderFns } from "./ConfirmRegistration.vue?vue&type=template&id=dd354ef8"
import script from "./ConfirmRegistration.vue?vue&type=script&lang=js"
export * from "./ConfirmRegistration.vue?vue&type=script&lang=js"
import style0 from "./ConfirmRegistration.vue?vue&type=style&index=0&id=dd354ef8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports